import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { BlockContent } from 'UI/Elements/Block';
import { Checkbox } from '@haldor/ui';

var GroupUserSelect = /*#__PURE__*/function (_Component) {
  _inherits(GroupUserSelect, _Component);

  var _super = _createSuper(GroupUserSelect);

  /* Class setup */
  function GroupUserSelect(props) {
    var _this;

    _classCallCheck(this, GroupUserSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var selected = [];

      if (_this.props.input.value != null && _this.props.input.value.length > 0) {
        _this.props.section.students.forEach(function (student) {
          if (_this.isStudentSelected(student)) {
            selected.push(student);
          }
        });
      } else {
        selected = _toConsumableArray(_this.props.section.students);
      }

      _this.setState({
        selected: selected
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isStudentSelected", function (student) {
      var value = _this.props.input.value;
      var section = _this.props.section;
      var selected = _this.state.selected;

      if (selected.length == 0) {
        return false;
      }

      var found = selected.find(function (selected) {
        return selected.id == student.id;
      });

      if (found != null) {
        return true;
      }

      if (value != null && value.length > 0) {
        var entireGroup = value.find(function (ref) {
          return _this.findSectionRelation(ref, section);
        });

        if (entireGroup != null) {
          return true;
        }

        var userRelation = value.find(function (ref) {
          return _this.findUserRelation(ref, student, section);
        });

        if (userRelation != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "findUserRelation", function (ref, student, section) {
      return ref.referenceType == 'USER' && ref.referenceId == student.id && ref.parentId == section.id;
    });

    _defineProperty(_assertThisInitialized(_this), "findSectionRelation", function (ref, section) {
      return ref.referenceType == 'SECTION' && ref.referenceId == section.id;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      var section = _this.props.section;
      var selected = _this.state.selected;
      var relationships = [];

      if (selected.length == section.students.length) {
        // All students selected in this section
        var relationship = null;

        if (_this.props.input.value != null && _this.props.input.value.length > 0) {
          _this.props.input.value.find(function (ref) {
            return _this.findSectionRelation(ref, section);
          });
        }

        if (relationship == null) {
          relationship = {
            id: -1,
            referenceType: 'SECTION',
            referenceId: section.id
          };
        }

        relationships.push(relationship);
      } else {
        // All students are not selected
        selected.forEach(function (student) {
          var relationship = null;

          if (_this.props.input.value != null && _this.props.input.value.length > 0) {
            relationship = _this.props.input.value.find(function (ref) {
              return _this.findUserRelation(ref, student, section);
            });
          }

          if (relationship == null) {
            relationship = {
              id: -1,
              referenceType: 'USER',
              referenceId: student.id,
              parentId: section.id,
              parentType: 'SECTION'
            };
          }

          relationships.push(relationship);
        });
      }

      if (_this.props.input != null) {
        _this.props.input.onChange(relationships);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onUserCheckboxClick", function (student) {
      var selected = _this.state.selected;
      var found = selected.findIndex(function (selected) {
        return selected.id == student.id;
      });

      if (found > -1) {
        selected.splice(found, 1);
      } else {
        selected.push(student);
      }

      _this.setState({
        selected: selected
      }, function () {
        _this.onChange();
      });
    });

    _this.state = {
      selected: []
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(GroupUserSelect, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      var _this2 = this;

      var section = this.props.section;
      return /*#__PURE__*/React.createElement("div", {
        className: "user-select single-group"
      }, /*#__PURE__*/React.createElement(BlockContent, {
        style: {
          position: 'relative',
          paddingTop: 0,
          paddingBottom: 0
        }
      }, section.students ? section.students.map(function (student) {
        return /*#__PURE__*/React.createElement("div", {
          key: student.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          onChange: function onChange() {
            return _this2.onUserCheckboxClick(student);
          },
          value: _this2.isStudentSelected(student),
          label: student.firstName + " " + student.lastName
        }));
      }) : null));
    }
  }]);

  return GroupUserSelect;
}(Component);

export default GroupUserSelect;